import { Box } from '@mui/material';
import { FC, ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router';
import useAuth from 'store/Auth/useAuth';

interface GuestProps {
  children?: ReactNode;
}

const GuestLayout: FC<GuestProps> = ({ children }) => {
  const { isLoggedIn } = useAuth();

  if (isLoggedIn) {
    return <Navigate to={'/dashboard'} />;
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {children || <Outlet />}
    </Box>
  );
};

export default GuestLayout;
